import { Injectable, Signal } from '@angular/core';
import { IDisclosureData, IDisclosureModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { DisclosureActions, DisclosureSelectors, IDisclosureState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class DisclosureStore extends StateAccessService<IDisclosureState> {
  readonly state$: Observable<IDisclosureState>;

  readonly data$$: Signal<IDisclosureData>;
  readonly model$$: Signal<IDisclosureModel>;

  constructor() {
    super();
    this.state$ = this.stateFacade.select$(DisclosureSelectors.disclosureState);
    this.model$$ = this.stateFacade.selectSignal$(DisclosureSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(DisclosureSelectors.data);
  }

  dispatchUpdateModel(model: IDisclosureModel) {
    this.stateFacade.dispatch(DisclosureActions.updateModel({ model }));
  }

  dispatchDisclosureReset() {
    this.stateFacade.dispatch(DisclosureActions.reset());
  }
  dispatchDisclosureLoad() {
    this.stateFacade.dispatch(DisclosureActions.load());
  }
  dispatchDisclosureLoadSuccess({ model, data }: { model: IDisclosureModel; data: IDisclosureData }) {
    this.stateFacade.dispatch(DisclosureActions.loadSuccess({ model, data }));
  }
  dispatchDisclosureSubmit() {
    this.stateFacade.dispatch(DisclosureActions.submit());
  }
  dispatchDisclosureSubmitSuccess({ model, data }: { model: IDisclosureModel; data: IDisclosureData }) {
    this.stateFacade.dispatch(DisclosureActions.submitSuccess({ model, data }));
  }
}
